// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const masterData = createApi({
  reducerPath: "masterApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getMasterData: builder.query({
      query: () => `master_data`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getSEOData: builder.query({
      query: (page) => ({ url: `seo_detail`, params: { page } }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    getBannerData: builder.query({
      query: (page) => ({ url: `banner`, params: { page } }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    getTestimonialData: builder.query({
      query: (page) => ({ url: `testimonial`, params: { page } }),

      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetMasterDataQuery,
  useGetSEODataQuery,
  useGetBannerDataQuery,
  useGetTestimonialDataQuery,
} = masterData;
